<template>
  <div class="background-image">
    <div class="container-full-page">
      <v-card style="border-radius: 20px;" class="px-4 pt-8 mx-4" elevation="8">
        <div class="container-form-login" style="display: flex; flex-direction: column;">
        <div class="form-container">
          <div
            class="content-image cursor-pointer mb-0"
            :class="{ 'content-image--embed': isEmbedLogin }"
          >
            <template v-if="isEmbedLogin">
              <div class="embed-brand embed-brand--login">
                <v-img
                  v-if="embedBranding.logoUrl"
                  :src="embedBranding.logoUrl"
                  :alt="embedBranding.name"
                  contain
                  max-height="90"
                />
                <div v-else class="embed-brand__name">
                  {{ embedBranding.name }}
                </div>
                <div class="embed-brand__powered">
                  <span>Powered by</span>
                  <v-img
                    :src="require('../../assets/logos/Logotipo_Dos tintas.png')"
                    alt="Fresher"
                    contain
                    max-width="105"
                    max-height="34"
                  />
                </div>
              </div>
            </template>
            <img
              v-else
              contain
              style="max-width: 400px; width: 100%; object-fit: contain; margin: auto;"
              src="../../assets/logos/Logotipo_Dos tintas.png"
              alt="Fresher-logo.png"
            >
          </div>
          <p class="text-title mon-bold mt-5" style="color: #193D6E;">{{ "¡Bienvenido!" }}</p>
          <p class="text-subtitle">{{ "Por favor, ingresa tu correo electrónico y contraseña para continuar" }}</p>
          <div class="mt-9 mx-4" style="width: 100%;">
            <v-text-field
              v-model="email"
              type="email"
              name="email"
              style="width: 100%;"
              outlined
              color="#000000"
              class="global-inputs mon-regular"
              :label="texts.login.inputEmail.label"
              :placeholder="texts.login.inputEmail.placeholder"
              persistent-placeholder
              @keypress="preLogin"
            ></v-text-field>
            <v-text-field
              v-model="password"
              name="password"
              style="width: 100%;"
              :append-icon="bShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :label="texts.login.inputPassword.label"
              :placeholder="texts.login.inputPassword.placeholder"
              @click:append="() => (bShowPassword = !bShowPassword)"
              :type="bShowPassword ? 'text' : 'password'"
              outlined
              color="#000000"
              class="global-inputs mon-regular mt-5"
              persistent-placeholder
              @keypress="preLogin"
            ></v-text-field>
          </div>
          <div class="center-horizontall mt-5">
            <v-btn
              @click="login"
              elevation="0"
              color="#0275b8"
              :loading="bLoading"
              class="button-login mon-bold px-12"
            >{{ 'Login' }}</v-btn>
          </div>
          <div v-if="!isEmbedLogin" class="center-horizontall mt-3">
            <v-btn
              to="/register"
              elevation="0"
              text
              color="#193D6E"
              class=""
              style="font-family: 'montserrat-bold'"
            >
              ¿No tienes cuenta? Regístrate
            </v-btn>
          </div>
        </div>
      </div>
      </v-card>
    </div>
    <div class="footer-login">
      <p class="footer-text-left mon-regular">
        ©{{ new Date().getFullYear() }} FRESHER. {{ texts.login.rights }}
      </p>
      <p class="footer-text-right mon-regular">
        <a href="/terms" class="footer-link">{{ texts.login.termCond }}</a> | 
        <a href="/privacy" class="footer-link">{{ texts.login.privacy }}</a>
      </p>
    </div>
  </div>
</template>

<script>
const embeddedLogos = require.context(
  "../../assets/embebedLogo",
  false,
  /\.png$/i
);

export default {
  name: "LoginView",
  data() {
    return {
      //VARIABLES
      screenHeight: 0,
      texts: "",
      email: "",
      password: "",
      bShowPassword: false,
      bLoading: false,
    };
  },
  beforeMount() {
    this.texts = FILE.login[this.selectLanguage];
    if (this.isEmbedLogin) {
      this.loadEmbedBranding();
    } else {
      this.$store.commit("setEmbedSession", false);
    }
  },
  methods: {
    async loadEmbedBranding() {
      const requestedSlug = this.integrationSlug;
      const normalizedSlug = decodeURIComponent(this.integrationSlug)
        .trim()
        .toLowerCase();

      const logoKey = embeddedLogos.keys().find(key => {
        const fileName = key
          .replace("./", "")
          .replace(/\.png$/i, "")
          .toLowerCase();

        return fileName === normalizedSlug;
      });

      let logoUrl = "";

      if (logoKey) {
        const resolvedLogo = embeddedLogos(logoKey);
        logoUrl = resolvedLogo.default || resolvedLogo;
      }

      this.$store.commit("setEmbedBranding", {
        name: logoKey ? normalizedSlug.toUpperCase() : "Cliente",
        logoUrl,
        primaryColor: "#193D6E",
        accentColor: "#0075B8",
      });

      try {
        const response = await DB.get(
          `${URI}/api/v1/${this.selectLanguage}/embed/${this.integrationSlug}/config`
        );

        if (this.isEmbedLogin && this.integrationSlug === requestedSlug) {
          this.$store.commit("setEmbedBranding", response.data.integration);
        }
      } catch (error) {
        // Keep the local fallback until the embed configuration endpoint is available.
      }
    },
    home() {
      this.$router.push("/home").catch(() => {});
    },
    changeLanguage(lang) {
      this.$store.commit("toggle_language", lang);
    },
    preLogin($event) {
      if ($event.code == "Enter") this.login();
    },
    login() {
      this.bLoading = true;

      const payload = {
        sEmail: this.email,
        sPassword: this.password,
      };

      const loginUrl =
        `${URI}/api/v1/${this.selectLanguage}/auth/customer` +
        (this.isEmbedLogin
          ? `?embedSlug=${encodeURIComponent(this.integrationSlug)}`
          : "");

      DB.post(loginUrl, payload)
        .then((response) => {
          this.bLoading = false;
          this.$store.commit("setEmbedSession", this.isEmbedLogin);
          if (this.isEmbedLogin) {
            this.$store.commit("setEmbedIntegrationSlug", this.integrationSlug);
          }
          this.$store.commit("setToken", response.data.sToken);
          this.$store.commit("setTypeUser", response.data.sTypeAccount);
          this.$store.commit("setOperationType", response.data.OperationType);
          if (response.data.sModelsAvaible.length === 0) {
            this.$store.commit("setModules", [
              { sModuleId: "182f53b8-0056-47aa-9638-a52f1f13cf78" },
            ]);
          } else {
            const mergedModules = [
              ...response.data.sModelsAvaible,
              { sModuleId: "182f53b8-0056-47aa-9638-a52f1f13cf78" },
            ];
            this.$store.commit("setModules", mergedModules);
          }
          // this.$store.commit("setEmail", response.data.sEmail);
          this.$store.commit("setFullName", response.data.sFullname);
          this.$store.commit("setEnterpriseId", response.data.sEnterpriseId);
          this.$store.commit("setUserId", response.data.sUserId);
          this.$store.commit("setIsLogged", true);
          this.$store.commit("setManager", response.data.bManager);

          this.mixInfo(response.data.sMessage);
          const availableIds = response.data.sModelsAvaible.map(mod => mod.sModuleId);

          if (this.isEmbedLogin) {
            this.$router.push({
              name: "EmbedDashboard",
              params: { slug: this.integrationSlug },
            }).catch(() => {});
            return;
          }

          if (availableIds.includes('b4f3e431-6e6f-4375-a49f-d2349ef2db1a')) {
            this.$router.push('/dashboard').catch(() => {});
          } else if (availableIds.includes('a4cf99f2-34db-4c4a-b7ff-3b718c02f84d')) {
            this.$router.push('/clientesFinancieroDeudor').catch(() => {});
          } else if (availableIds.includes('b5c838b1-4797-4296-903d-e08d6e9c4389')) {
            this.$router.push('/clientesFinanciero').catch(() => {});
          } else {
            this.$router.push('/products').catch(() => {});
          }
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
  },
  computed: {
    isEmbedLogin() {
      return !!this.$route.meta.embedGuest;
    },
    integrationSlug() {
      return this.$route.params.slug || "";
    },
    embedBranding() {
      return this.$store.state.embedBranding;
    },
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    '$route'() {
      if (this.isEmbedLogin) {
        this.loadEmbedBranding();
      } else {
        this.$store.commit("setEmbedSession", false);
      }
    },
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.login[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
  .embed-brand {
    min-height: 150px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .embed-brand--login {
    width: 100%;
    box-sizing: border-box;
  }

  .embed-brand__name {
    color: #193d6e;
    font-family: "montserrat-bold";
    font-size: 24px;
    text-align: center;
  }

  .embed-brand__powered {
    margin-top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #687586;
    font-size: 11px;
  }

  .language-buttons {
    display: flex;
    gap: 10px;
  }
  .language-buttons button {
    border: none;
    background: none;
    cursor: pointer;
  }
  .language-buttons .selected {
    background-color: #B8C7D4;
  }
  .Header {
    justify-content: space-between;
    display: flex;
    align-items: center; 
    flex-direction: row;
    padding: 20px;
  }
  .header-content {
    display: flex;
    align-items: center;;
    width: 100%;
  }
  .language-selector {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .menu-language {
    background-color: #EDF3FF;
  }
  .flag-image {
    width: 50px;
    align-items: center;
    justify-content: center;
    padding-left: 7px;
    padding-right: 7px;
    padding-top: 7px;
    padding-bottom: 0px;
  }
  .account-section {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin-left: auto;
  }
  .Btn-Account {
    border: 2px solid #0075B8;
    color: #0075B8;
    background-color: #fff;
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .Btn-Account:hover {
    background-color: #0075B8;
    color: #fff;
  }
  .Btn-text {
    display: flex;
    justify-content: center;
    align-items: center; 
    width: 10vw;
    margin-right: 15px;
    margin-top: 15px;
  }
  .form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  .container-full-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    align-items: center;
  }
  .container-form-login {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  }
  .footer-login {
    width: 100%;
    padding: 10px 20px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    background: transparent;
    bottom: 0px;
  }
  .footer-text-left,
  .footer-text-right {
    font-size: 12px;
    color: #FFFFFF;;
  }
  .footer-link {
    color: #FFFFFF;
    text-decoration: none;
  }
  .footer-link:hover {
    text-decoration: underline;
  }
  .button-create-account {
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #283c4d;
    border-radius: 12px;
    opacity: 1;
    background-color: #ffffff !important;
    text-transform: initial;
    font-size: 14px;
    width: 100%;
  }
  .link-forgot-password {
    text-transform: initial;
    color: #0049b7;
    text-decoration: underline;
    letter-spacing: 0px;
  }
  .button-login {
    width: 100%;
    height: 40px !important;
    border-radius: 10px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
    text-transform: initial;
  }
  .text-title {
    font-size: 30px;
    text-align: center;
    letter-spacing: 0px;
  }
  .text-subtitle {
    font-size: 15px;
    text-align: center;
    letter-spacing: 0px;
    font-weight: 100;
  }
  .center-horizontall {
    display: flex;
    justify-content: center;
  }

  .content-image {
    width: 260px;
    height: 45px;
  }

  .content-image--embed {
    width: 300px;
    height: auto;
    min-height: 150px;
    margin-bottom: 20px;
  }

  .content-image--embed .embed-brand {
    min-height: 150px;
    padding: 16px 24px;
  }

  .content-image > img {
    width: 100%;
    height: auto;
  }

  @supports (object-fit: cover) {
    .content-image > img {
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }

  .content-login {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: -13%;
  }

  @media (max-width: 720px) {
    .form-container {
      width: 80vw;
      height: auto;
    }

    .text-title {
      font-size: 25px;
    }
  }
  .background-image {
    background-image: url('../../assets/images/login-cover.png');
    background-size: cover;
    background-position: center;
  }
</style>
